// src/features/videos/panels/TopCreatorsPanel.tsx — right-rail creators with a
// working Follow. Thin wrapper around the shared CreatorsPanel (slice-4-xl S4
// — this used to duplicate Live's TopLiveCreatorsPanel byte-for-byte).
import { CreatorsPanel } from '@/components/CreatorsPanel/CreatorsPanel';
import type { VideoCreator } from '@/core/models/video';

export interface TopCreatorsPanelProps {
  creators: VideoCreator[];
}

export function TopCreatorsPanel({ creators }: TopCreatorsPanelProps) {
  return <CreatorsPanel title="Top creators" creators={creators} />;
}
